import { render, staticRenderFns } from "./ReviewButtons.vue?vue&type=template&id=06837f7a&scoped=true"
import script from "./ReviewButtons.vue?vue&type=script&lang=js"
export * from "./ReviewButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06837f7a",
  null
  
)

export default component.exports